import React from 'react';
import { Select, Space, Tag } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { useTenant } from '../contexts/TenantContext';

const PLAN_COLORS: Record<string, string> = {
  free: 'default',
  basic: 'blue',
  pro: 'gold',
  enterprise: 'purple',
};

const TenantSelector: React.FC = () => {
  const { currentTenant, tenants, switchTenant } = useTenant();

  if (tenants.length <= 1) return null;

  return (
    <div
      style={{
        height: 40,
        padding: '0 12px',
        borderRadius: 12,
        border: '1px solid #E7EDF4',
        background: '#F8FAFD',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Space size={8}>
        <TeamOutlined style={{ color: '#1677FF' }} />
        <Select
          value={currentTenant?.id}
          onChange={switchTenant}
          style={{ minWidth: 172 }}
          size="small"
          variant="borderless"
          popupMatchSelectWidth={240}
          options={tenants.map((tenant) => ({
            value: tenant.id,
            label: (
              <Space>
                <span>{tenant.name}</span>
                <Tag color={PLAN_COLORS[tenant.plan] || 'default'} style={{ marginRight: 0 }}>
                  {tenant.plan}
                </Tag>
                {tenant.status === 'suspended' && <Tag color="orange" style={{ marginRight: 0 }}>只读</Tag>}
              </Space>
            ),
          }))}
        />
      </Space>
    </div>
  );
};

export default TenantSelector;
